<template>
    <div class="update_info" v-if="showInfoUpates && version?.need_update">
        <button class="update_info__close" @click="close">
            <i class="fa fa-times"></i>
        </button>
        <div class="update_info__title">
            Есть обновления, Вам необходимо обновить систему!
        </div>
        <div class="update_info__current-version">
            Ваша версия web-приложения KPam-3D: v
            {{ version.current_version_number }}
        </div>
        <div class="update_info__new-version">
            Актуальная версия web-приложения KPam-3D: v
            {{ version.version_number }}
        </div>
        <router-link class="btn btn-green btn-small" :to="{ name: 'updates' }"
            >Обновить</router-link
        >
    </div>
</template>
<script>
export default {
    name: "UpdateInfo",
    props: {
        routeNameProps: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            showInfoUpates: true,
        };
    },
    computed: {
        version() {
            return this.$store.state.versions.version;
        },
    },
    created() {
        if (this.routeNameProps === "updates") this.showInfoUpates = false;
    },
    methods: {
        close() {
            this.showInfoUpates = false;
        },
    },
};
</script>
<style scoped>
.update_info {
    padding: 20px;
    border: 1px solid #cfe2e8;
    border-radius: 4px;
    margin: auto 30px;
    margin-bottom: 20px;
    position: relative;
}
.update_info__close {
    position: absolute;
    top: 10px;
    right: 15px;
}
.update_info__title {
    font-size: 18px;
    color: #ff0000;
    margin-bottom: 7px;
}
.update_info__current-version {
    font-size: 14px;
    margin-bottom: 4px;
}
.update_info__new-version {
    font-size: 14px;
    color: #009543;
    margin-bottom: 10px;
}
</style>
